import React, { useState } from 'react';
import ModalBase from 'components/Tvendo/Common/ModalBase';
import { FileUploader } from 'react-drag-drop-files';
import { wsCreate, wsRemove } from 'services/WService';
import Button from 'components/CustomButtons/Button.js';
import SweetAlert from 'react-bootstrap-sweetalert';
import { makeStyles } from '@material-ui/core/styles';
import styles from 'assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';

const fileTypes = ['JPG', 'PNG'];

const useStyles = makeStyles(styles);

/**
 * Foto de un registro, para cualquier entidad que exponga /{id}/photo.
 *
 * No muestra título ni nombre: la fila desde la que se abre ya dice de qué
 * registro se trata, y repetirlo solo achica la imagen.
 *
 * @param entity  base del endpoint, por ejemplo 'base/furniture'.
 * @param texto   qué se está borrando, para la confirmación.
 * @param updatePermission  permiso para subir o borrar la foto; sin él solo se ve.
 *                          Si no se pasa, cualquiera puede subir o borrar.
 */
export default function PhotoModal({ model, setOpen, showNotify, reload, entity, texto, updatePermission }) {
  const classes = useStyles();
  const [processing, setProcessing] = useState(false);
  const [iteration, setIteration] = useState(1);
  const [alerta, setAlerta] = useState(null);

  //el backend borra primero del bucket y recien despues limpia la fila, asi que
  //si esto responde ok la imagen ya no esta en S3
  async function borrarFoto() {
    setProcessing(true);
    let res = await wsRemove(`${entity}/${model.id}/photo`);
    setProcessing(false);

    if (res.success) {
      showNotify(res.message);
      setOpen({ ...model, file_url: null });
      reload();
    } else {
      showNotify(res.message, 'error');
    }
  }

  function confirmarBorrado() {
    setAlerta(
      <SweetAlert
        warning
        style={{ display: 'block', marginTop: '-100px' }}
        title={`¿Eliminar la foto${texto ? ' ' + texto : ''}?`}
        onConfirm={() => {
          setAlerta(null);
          borrarFoto();
        }}
        onCancel={() => setAlerta(null)}
        confirmBtnCssClass={classes.button + ' ' + classes.success}
        cancelBtnCssClass={classes.button + ' ' + classes.danger}
        confirmBtnText="Aceptar"
        cancelBtnText="Cancelar"
        showCancel
      >
        Se borra del almacenamiento y no se puede recuperar.
      </SweetAlert>
    );
  }

  async function handleChange(file) {
    let fd = new FormData();
    fd.append('photo', file);

    setProcessing(true);
    let res = await wsCreate(`${entity}/${model.id}/photo`, fd);
    setProcessing(false);

    if (res.success) {
      showNotify(res.message);
      //el ?v= fuerza al navegador a recargarla: la URL no cambia al reemplazarla
      setOpen({ ...model, file_url: `${res.data.file_url}?v=${iteration}` });
      setIteration((it) => it + 1);
      reload();
    } else {
      showNotify(res.message, 'error');
    }
  }

  return (
    <>
      {alerta}
      <ModalBase model={model} setOpen={setOpen} hideSave maxWidth="sm" title="">
        {model?.file_url && !processing && (
          <div style={{ width: '100%', maxWidth: '450px', marginBottom: '16px' }}>
            <img src={model.file_url} alt="" style={{ width: '100%', display: 'block' }} />
          </div>
        )}

        {processing && (
          <div style={{ width: '350px', height: '200px', display: 'flex', flexDirection: 'column' }}>
            <div style={{ alignSelf: 'center', width: '60px', height: '60px', marginTop: '45px' }}>
              <div className="lds-dual-ring"></div>
            </div>
          </div>
        )}

        {model?.file_url && !processing && (
          <AllowedGuard permission={updatePermission}>
            <Button color="danger" fullWidth disabled={processing} onClick={confirmarBorrado}>
              Eliminar
            </Button>
          </AllowedGuard>
        )}

        {!model?.file_url && (
          <AllowedGuard permission={updatePermission} component={<p>Sin foto</p>}>
            <FileUploader
              handleChange={handleChange}
              name="photo"
              types={fileTypes}
              disabled={processing}
              label="Has click o arrastra una imagen aquí"
              hoverTitle="Suelta la imagen aquí"
              maxSize={2}
            />
          </AllowedGuard>
        )}
      </ModalBase>
    </>
  );
}
